<template>
    <div v-if="existAlert" class="card-products alerts">
        <div class="item delete" :class="{ inactive: timerproduct['to_delete'] == 0 }">
            <div class="icon" :class="{ 'timer-pulse-card': timerproduct['to_delete'] > 0 }"></div>
            <div class="alert">
                <span class="number delete">{{ formatDisplayNumber(timerproduct['to_delete']) }}</span>
                <span class="label">{{ $t(`widget.product_to_be_discarded`).toUpperCase() }}</span>
            </div>
        </div>

        <div class="item expiration" :class="{ inactive: timerproduct['close_to_expire'] == 0 }">
            <div class="icon"></div>
            <div class="alert">
                <span class="number expiration">{{ formatDisplayNumber(timerproduct['close_to_expire']) }}</span>
                <span class="label">{{ $t(`widget.close_to_expire`) }}</span>
            </div>
        </div>
        
        <div v-if="showWithoutTimers" class="item unknown" :class="{ inactive: timerproduct['without_timer'] == 0 }">
            <div class="icon"></div>
            <div class="alert">
                <span class="number">{{ formatDisplayNumber(timerproduct['without_timer']) }}</span>
                <span class="label">{{ $t(`widget.without_timers`) }}</span>
            </div>
        </div>
    </div>
    <div v-else class="card-products empty">
        <div class="img-empty"></div>
        <label class="without-alerts">{{ $t(`widget.without_alerts`).toUpperCase() }}</label>
    </div>
</template>

<script>
import { formatNumberLabel } from '@/utils/numberFormat'
import { TOOLS } from '@/constants'

const PRODUCT_TIMERS_WIDGET_REFRESH_MS = 5 * 60 * 1000

export default {
    name: 'CardProductTimers',
    props: {
        details: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            cssImage: css_image_url,
            interval: null
        }
    },
    computed: {
        timerproduct() {
            return this.$store.getters['timerproduct/getHomeWidgetData']
        },
        showWithoutTimers() {
            const config = this.$store.getters['login/getConfig'] || {}
            return config.productsWithoutTimers !== false
        },
        existAlert() {
            if (this.timerproduct['to_delete'] > 0) return true
            if (this.showWithoutTimers && this.timerproduct['without_timer'] > 0) return true
            return false
        },
        layoutLoadsProductTimers() {
            const tools = (this.$store.getters['login/getConfig'] || {}).tools || []
            return tools.includes(TOOLS.PRODUCT_TIMERS)
        }
    },
    mounted() {
        if (!this.layoutLoadsProductTimers) {
            this.updateTimers()
        }
        this.interval = setInterval(() => {
            this.updateTimers()
        }, PRODUCT_TIMERS_WIDGET_REFRESH_MS)
    },
    beforeDestroy() {
        if (this.interval) {
            clearInterval(this.interval)
            this.interval = null
        }
    },
    methods: {
        formatDisplayNumber(value, fractionDigits) {
            return formatNumberLabel(value, this.$i18n.locale, fractionDigits)
        },
        updateTimers() {
            this.$store.dispatch('timerproduct/loadTimers')
        }
    }
}
</script>

<style lang="scss" scoped>
.card-products {
    height: calc(100% - 60px);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 8px;
    align-items: unset;
    width: 100%;

    &.empty {
        align-content: space-around;
        flex-wrap: wrap;
    }
    .delete{
        .alert{
            .number{
                color: #757575;
            }
        }
        .icon{
            @include background($image: img('trash.svg'), $position: center center, $size: 56px);
            background-color: #757575;
        }
    }
    .expiration{
        .alert{
            .number{
                color: $color-warning-500;
            }
        }
        .icon{
            @include background($image: img('clock-circular-outline.svg'), $position: center center, $size: 62px);
            background-color: $color-warning-500;
        }
    }
    .unknown{
        .alert{
            .number{
                color: $color-warning-500;
            }
        }
        .icon{
            @include background($image: img('clock-circular-outline.svg'), $position: center center, $size: 62px);
            background-color: $color-warning-500;
        }
    }
    .item {
        display: flex;
        height: 50%;

        .icon {
            padding: 0px 12px;
            display: flex;
            justify-content: center;
            border-radius: 4px;
            width: 100px;

        }
        .alert {
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            gap: 8px;
            padding-left: 16px;

            .number {
                font-size: 65px;
                line-height: 65px;
                font-family: $title-bold;
            }
            .label {
                color: $color-neutral-600;
                @include font-size(m);
                font-family: $text-light;
                text-transform: uppercase;
            }
        }

        &.inactive {
            .icon {
                background-color: $color-neutral-400;
            }
            .alert {
                .number {
                    color: $color-neutral-400 !important;
                }
            }
        }
    }
    .without-alerts {
        font-size: 18px;
        font-weight: 600;
        color: #2e2d2d;
    }
    .img-empty {
        height: 120px;
        width: 120px;
        @include background($image: img('andy-happy.svg'), $position: center center, $size: 116px);
    }
}
</style>
